import { Flex } from 'components/base/layout-components';
import React from 'react';
import characterBurn from 'images/characters/character-burn.svg';
import styled from 'styled-components';
import Text from 'components/base/Text';
import { Link } from '@material-ui/core';
import { LINE_HEIGHT, SPACES } from 'common/constants/sizes';
import { openSupportRequest } from 'common/services/zendesk.service';
import { learnMoreSlackTroubleshooting } from 'common/constants/articles';
import { LBButton } from '@linearb/buzz';

const StyledSVG = styled.img`
  width: 12rem;
`;

const ExistingSlackWorkspaceModal = () => {
  return (
    <Flex direction='column' items='center' padding='medium' pt='large'>
      <StyledSVG src={characterBurn} alt='' />
      <Text
        size='x-large'
        lineHeight={LINE_HEIGHT['large']}
        color='shuttleGray'
        align='center'
        weight='300'
        pt={SPACES.medium}
        pb={SPACES.medium}
      >
        You are trying to connect to a workspace used by another team in your
        company...
      </Text>
      <LBButton size='lg' onClick={openSupportRequest}>
        Contact Support for help
      </LBButton>
      <Text size='medium' pt={SPACES.medium}>
        <Link
          onClick={() => window.open(learnMoreSlackTroubleshooting, '_blank')}
        >
          learn more
        </Link>
      </Text>
    </Flex>
  );
};

export default ExistingSlackWorkspaceModal;
